var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper-menu d-flex align-items-center justify-content-end py-3 px-auto px-md-0 col-5 col-sm-6 col-lg-5"},[_c('LazyLayoutsHeaderTheMenuDropdown',{attrs:{"main-menu":_vm.mainMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }